import {Component, input} from '@angular/core';
import {Visibility} from '../../../models/prompt.model';
import {IconComponent} from '../icon/icon.component';
import {TitleCasePipe} from '@angular/common';

@Component({
  selector: 'app-visibility',
  imports: [
    IconComponent,
    TitleCasePipe
  ],
  template: `
    <icon [type]="value()"/>
    <span>{{ value() | titlecase }}</span>
  `,
  host: {
    class: 'app-row-auto centered-items gapped tight'
  }
})
export class VisibilityComponent {
  readonly value = input.required<Visibility>()
}
